(function() {
  function initCollectionPills() {
    const pillsWrap = document.querySelector('[data-collection-pills]');
    if (!pillsWrap) return;

    const buttons = pillsWrap.querySelectorAll('.tshirt-pill-btn');
    const productGrid = document.querySelector('#product-grid');
    if (!productGrid) return;

    const productCards = Array.from(productGrid.querySelectorAll('.grid__item'));

    const filterKeywords = {
      all: [],
      programmer: ['programmer', 'coder', 'developer', '404', 'backend', 'engineer', 'code'],
      zodiac: ['zodiac', 'astrology', 'aquarius', 'aries', 'cancer', 'gemini', 'leo', 'virgo', 'libra', 'scorpio', 'sagittarius', 'capricorn', 'pisces', 'taurus'],
      alien: ['alien', 'ufo', 'sci-fi', 'area 51', 'abduction', 'space'],
      cat: ['cat', 'bengal', 'kitty', 'feline', 'pet'],
      techno: ['techno', 'berlin', 'rave', 'music', 'electronic', 'club', 'retro']
    };

    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        buttons.forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        const tag = btn.getAttribute('data-filter-tag');
        const keywords = filterKeywords[tag] || [];

        productCards.forEach(function(card) {
          if (tag === 'all' || keywords.length === 0) {
            card.style.display = '';
            card.classList.remove('is-filtered-out');
            return;
          }

          const titleEl = card.querySelector('.card__heading a, [id^="CardLink-"]');
          const titleText = (titleEl ? titleEl.textContent : '').toLowerCase();
          const handle = (card.querySelector('[data-product-handle]')?.getAttribute('data-product-handle') || '').toLowerCase();

          const matches = keywords.some(k => titleText.includes(k) || handle.includes(k));

          if (matches) {
            card.style.display = '';
            card.classList.remove('is-filtered-out');
          } else {
            card.style.display = 'none';
            card.classList.add('is-filtered-out');
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionPills);
  } else {
    initCollectionPills();
  }
})();
